import { useTranslate } from "#src/hooks";
import { Flex, FlexProps, Typography } from "antd";
import { formatAcceptedFormats } from "helpers/uploader/";

interface UpdateInfoProps extends FlexProps {
  acceptedMimeTypes?: string;
  maxFileSize?: number;
  // Storybook global args that should not be passed to DOM
  mode?: string;
  docustream?: boolean;
}
export const UploadInfo = ({
  acceptedMimeTypes,
  maxFileSize,
  mode,
  docustream,
  ...props
}: UpdateInfoProps) => {
  const t = useTranslate();
  return (
    <Flex
      vertical
      align="center"
      gap={5}
      style={{ textAlign: "center" }}
      {...props}
    >
      <Typography.Text>
        {t("src.components.UploadFiles.clickOrDrag")}
      </Typography.Text>
      <AcceptedFormats acceptedMimeTypes={acceptedMimeTypes} />
      {!!maxFileSize && (
        <Typography.Text type="secondary">
          {t("src.components.UploadFiles.maxFileSize", { size: maxFileSize })}
        </Typography.Text>
      )}
    </Flex>
  );
};

export const AcceptedFormats = ({
  acceptedMimeTypes,
}: {
  acceptedMimeTypes: string;
}) => {
  const t = useTranslate();
  if (!acceptedMimeTypes) return null;
  return (
    <Typography.Text type="secondary">
      {t("src.components.UploadFiles.acceptedFormats")}{" "}
      {formatAcceptedFormats(acceptedMimeTypes)}
    </Typography.Text>
  );
};
